import { defineStore } from "pinia";
import { GeofenceInfo } from "src/models/server";
import { api } from "boot/axios";

export const useServerStore = defineStore({
  id: "server",
  state: () => ({
    geofenceInfo: null as null | GeofenceInfo
  }),
  actions: {
    async fetchGeofenceInfo(): Promise<GeofenceInfo> {
      const res = await api.get("/api/v2/server/geofence");
      this.geofenceInfo = res.data as GeofenceInfo;
      return this.geofenceInfo;
    }
  }
});